import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { LocalizedLink } from "@/i18n/language";
import { img } from "@/lib/images";

const sections = [
  {
    titleKey: "health_sports_spa_title",
    textKey: "health_sports_spa_text",
    img: img("activities/health-sports/health-sports-spa-01.jpg"),
    imgAlt: "Spa Behandlungen auf Bali",
  },
  {
    titleKey: "health_sports_cycling_title",
    textKey: "health_sports_cycling_text",
    img: img("activities/health-sports/health-sports-cycling-01.jpg"),
    imgAlt: "Fahrradtouren auf Bali",
  },
  {
    titleKey: "health_sports_fitness_title",
    textKey: "health_sports_fitness_text",
    img: img("activities/health-sports/health-sports-fitness-01.jpg"),
    imgAlt: "Gladiator Fitness Bali",
  },
];

export default function HealthSportsPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("health_sports_eyebrow")}
          title={t("health_sports_title")}
          subtitle={t("health_sports_intro")}
          image={img("activities/health-sports/header-health-sports_01.jpg")}
          imageAlt="Gesundheit und Sport auf Bali"
        />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
              {/* Main content */}
              <div className="lg:col-span-2 space-y-8">
                {sections.map((section, idx) => (
                  <div key={idx} className="space-y-4">
                    <div className="rounded-lg overflow-hidden border border-background-200 aspect-[4/3]">
                      <img
                        src={section.img}
                        alt={section.imgAlt}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <h2 className="font-heading text-xl md:text-2xl text-foreground-950">
                      {t(section.titleKey)}
                    </h2>
                    <div className="w-10 h-0.5 bg-accent-500"></div>
                    <p className="text-sm text-foreground-700 leading-relaxed whitespace-pre-line">
                      {t(section.textKey)}
                    </p>
                  </div>
                ))}
              </div>

              {/* Sidebar */}
              <div className="lg:col-span-1">
                <div className="bg-background-100 border border-background-200 rounded-lg p-6 sticky top-24">
                  <div className="eyebrow-brand text-xs uppercase tracking-[0.3em] mb-3">
                    — {t("activities_eyebrow")} —
                  </div>
                  <nav className="space-y-1">
                    <LocalizedLink
                      to="/tour-info"
                      className="block px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors"
                    >
                      {t("tour_category_info_title")}
                    </LocalizedLink>
                    <LocalizedLink
                      to="/day-trips"
                      className="block px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors"
                    >
                      {t("tour_category_daytrips_title")}
                    </LocalizedLink>
                    <LocalizedLink
                      to="/multi-day-tours"
                      className="block px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors"
                    >
                      {t("tour_category_multiday_title")}
                    </LocalizedLink>
                    <LocalizedLink
                      to="/adventure-tours"
                      className="block px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors"
                    >
                      {t("tour_category_adventure_title")}
                    </LocalizedLink>
                    <LocalizedLink
                      to="/shopping-bali"
                      className="block px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors"
                    >
                      {t("nav_activities_shopping")}
                    </LocalizedLink>
                    <LocalizedLink
                      to="/health-sports"
                      className="block px-3 py-2.5 rounded-md text-sm font-medium bg-accent-50 text-accent-700"
                    >
                      {t("nav_activities_health")}
                    </LocalizedLink>
                  </nav>
                  <div className="mt-6 pt-4 border-t border-background-200">
                    <LocalizedLink
                      to="/activities"
                      className="inline-flex items-center gap-2 text-sm text-accent-700 hover:text-accent-800 transition-colors"
                    >
                      <i className="ri-arrow-left-line"></i>
                      {t("health_sports_back")}
                    </LocalizedLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                {t("health_sports_cta_title")}
              </h2>
              <p className="mt-2 text-foreground-700 text-sm">
                {t("health_sports_cta_sub")}
              </p>
            </div>
            <LocalizedLink
              to="/activities"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-100 text-background-50 hover:text-foreground-950 px-7 py-3.5 rounded-md font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              {t("health_sports_back")}
            </LocalizedLink>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}